import React from 'react';
import './harbour.css';

/*
 * Harbour radio options: full-width rows, one choice per moment. Selection
 * reads as filled surface + control change + label, never a hue shift alone.
 * `tone` follows the journey: 'senco' (plum), 'sen' (green) or 'referral' (blue).
 *
 * Rows are real radios to assistive tech. A row may carry a trailing action
 * (e.g. "Remove"); it is a sibling of the radio, never nested inside it.
 */
export default function HarbourOptionGroup({ options = [], value, onChange, tone = 'senco', ariaLabel }) {
  const onKeyDown = (opt) => (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      onChange(opt.value);
    }
  };
  return (
    <div className="harbour-options" role="radiogroup" aria-label={ariaLabel}>
      {options.map((opt) => {
        const selected = value === opt.value;
        return (
          <div
            key={opt.value}
            className={[
              'harbour-option',
              tone === 'referral' ? 'harbour-option--referral' : '',
              tone === 'sen' ? 'harbour-option--sen' : '',
              selected ? 'harbour-option--selected' : '',
            ].filter(Boolean).join(' ')}
            onClick={() => onChange(opt.value)}
          >
            <span
              role="radio"
              aria-checked={selected}
              aria-label={opt.label}
              tabIndex={0}
              onKeyDown={onKeyDown(opt)}
              className="harbour-option__radio"
            />
            <span className="harbour-option__body">
              {opt.label}
              {opt.meta && <span className="harbour-option__meta">{opt.meta}</span>}
            </span>
            {opt.trailing && <span className="flex-none">{opt.trailing}</span>}
          </div>
        );
      })}
    </div>
  );
}
